var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBusinessBlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.556,
    height: 25,
    viewBox: "0 0 27.556 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-briefcase",
    "data-name": "Icon feather-briefcase",
    transform: "translate(-2 -3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_20",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 20",
    d: "M5.556,10.5H26a2.494,2.494,0,0,1,2.556,2.429V25.071A2.494,2.494,0,0,1,26,27.5H5.556A2.494,2.494,0,0,1,3,25.071V12.929A2.494,2.494,0,0,1,5.556,10.5Z",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#242323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_21",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 21",
    d: "M24,27.5V7.056A2.8,2.8,0,0,0,21,4.5H15a2.8,2.8,0,0,0-3,2.556V27.5",
    transform: "translate(-2.222 0)",
    fill: "none",
    stroke: "#242323",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessBlack);
export default __webpack_public_path__ + "static/media/business_black.515d18019ebe5b9d8ae540ee2f095fa0.svg";
export { ForwardRef as ReactComponent };